module.exports = __webpack_public_path__ + "static/img/Secondary miner.ec43ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Secondary miner.png
// module id = fEX2
// module chunks = 2